export const CALCULATION_LEGISLATION = {
    'CALCULATION.LEGISLATION.DRAWER.TITLE': 'Legislație aplicabilă',
    'CALCULATION.LEGISLATION.ACTION': 'Legislație'
};
